import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import FeedPage from './pages/FeedPage.vue'
import HeaderNav from './components/HeaderNav.vue'
import LoaderAni from './components/shared/LoaderAni.vue'
import helpers from "./mixins/helpers.js"
import members from "./mixins/members.js"
import VueGtag from "vue-gtag"
import BannerMessage from "./components/shared/BannerMessage.vue"

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: "/", name: "feed", component: () => import('./pages/FeedPage.vue') },
        { path: "/account", component: () => import('./pages/AccountPage.vue') },
        { path: "/create-profile", component: () => import('./pages/CreateProfile.vue') },
        { path: "/create-event", component: () => import('./pages/CreateEvent.vue') },
        { path: "/artist", component: () => import('./pages/ProfilePage.vue') },
        { path: "/events", component: () => import('./pages/EventsFeed.vue') },
        { path: "/events/:slug", component: () => import('./pages/EventDetail.vue') },
        { path: "/contact", component: () => import('./pages/ContactPage.vue') },
        { path: "/auth", component: () => import('./pages/AuthPage.vue') },
        { path: "/test-page", component: () => import('./pages/TestPage.vue') },
        { path: "/:slug", component: () => import('./pages/ProfilePage.vue') },
        { path: "/404", component: () => import('./pages/ErrorPage.vue') },
    ],
    linkActiveClass: 'active'
})

const app = createApp(App)

app.use(router)
app.mixin(helpers)
app.mixin(members)
app.component('banner-message', BannerMessage)
app.component('header-nav', HeaderNav)
app.component('feed-page', FeedPage)
app.component('loader-ani', LoaderAni)

app.use(VueGtag, {
    pageTrackerExcludedRoutes: [
        '/test-page',
        '/auth'
    ],
    config: {
        id: process.env.VUE_APP_GOOGLE_MEASUREMENT_ID, params: {
            anonymize_ip: true
        }
    }
}, router)

app.mount('#app')

// to run app in production mode and use .env.production:
// vue-cli-service build --mode production